import { render, staticRenderFns } from "./modal-base.vue?vue&type=template&id=5dd034bf&scoped=true"
import script from "./modal-base.vue?vue&type=script&lang=js"
export * from "./modal-base.vue?vue&type=script&lang=js"
import style0 from "./modal-base.vue?vue&type=style&index=0&id=5dd034bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd034bf",
  null
  
)

export default component.exports